import { render, staticRenderFns } from "./Table2.vue?vue&type=template&id=1420662c&scoped=true"
import script from "./Table2.vue?vue&type=script&lang=js"
export * from "./Table2.vue?vue&type=script&lang=js"
import style0 from "./Table2.vue?vue&type=style&index=0&id=1420662c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1420662c",
  null
  
)

export default component.exports